import {http} from '@/utils';
import type {
  ActivityPay,
  ActivityRechargeAward,
  BalanceConfig,
} from '@fe-progressive/package-progressive/recharge';

export type {ActivityPay, ActivityRechargeAward, BalanceConfig};

// 后台接口返回的数据结构
export interface RechargeTabApiResponse {
  code: number;
  message: string;
  data: RechargeTabApiItem[];
}

export interface RechargeTabApiRule {
  name: string;
  minAmount: number;
  maxAmount: number;
  valueType: 'PERCENT_VALUE' | 'FIXED_VALUE';
  value: string;
}

export interface RechargeTabApiItem {
  id: number;
  icon: string; // 图标URL
  title: string; // 文案
  bonus?: string; // 左上角数值，如 "50% BONUS"
  bonusText?: string; // 比例和文案
  backgroundIndex: number; // 背景图索引 01-10
  isActive?: boolean; // 是否激活
  rules?: RechargeTabApiRule[];
  minAmount?: number;
  maxAmount?: number;
}

// 模拟后台接口数据
// 后台数据还包含规则信息，
// rules: [{
//     name: '1st',
//     minAmount: 200,
//     maxAmount: 5000,
//     valueType: 'PERCENT_VALUE', // 百分比，非PERCENT_VALUE固定值
//     value: '100'

// }]
export const mockRechargeTabData: RechargeTabApiItem[] = [
  {
    id: 1,
    icon: require('@/assets/imgs/recharge/frist.webp'),
    title: 'LIMITED TIME FIRST CHARGE',
    bonus: '50%',
    bonusText: 'BONUS',
    backgroundIndex: 1,
    isActive: true,
    minAmount: 200,
    maxAmount: 5000,
    rules: [
      {
        name: '1st',
        minAmount: 200,
        maxAmount: 5000,
        valueType: 'PERCENT_VALUE',
        value: '100',
      },
    ],
  },
  {
    id: 2,
    icon: require('@/assets/imgs/recharge/505.webp'),
    title: 'FIRST DEPOSIT 50% BONUS EVENT',
    bonus: '50%',
    bonusText: 'BONUS',
    backgroundIndex: 2,
    isActive: false,
    minAmount: 100,
    maxAmount: 10000,
    rules: [
      {
        name: '2nd',
        minAmount: 100,
        maxAmount: 10000,
        valueType: 'PERCENT_VALUE',
        value: '100',
      },
      {
        name: '2nd-1',
        minAmount: 100,
        maxAmount: 2000,
        valueType: 'PERCENT_VALUE',
        value: '20',
      },
    ],
  },
  {
    id: 3,
    icon: require('@/assets/imgs/recharge/vip.webp'),
    title: 'VIP RECHARGE EVENT',
    bonus: '',
    bonusText: '',
    backgroundIndex: 3,
    isActive: false,
    // minAmount: 100,
    // maxAmount: 10000,
    rules: [
      {
        name: '0-1',
        minAmount: 100,
        maxAmount: 10000,
        valueType: 'PERCENT_VALUE',
        value: '100',
      },
      {
        name: '0-2',
        minAmount: 200,
        maxAmount: 10000,
        valueType: 'FIXED_VALUE',
        value: '100',
      },
    ],
  },
  {
    id: 4,
    icon: require('@/assets/imgs/recharge/weekcard.webp'),
    title: 'WEEKLY CARD RECHARGE ACTIVITY',
    bonus: '',
    backgroundIndex: 4,
    isActive: false,
    // 周卡规则需要单独获取
    rules: [],
  },
];

// // 获取充值tab数据的接口
// export const getRechargeTabData = async (): Promise<RechargeTabItem[]> => {
//   try {
//     // 这里应该是真实的API调用
//     // const response = await fetch('/api/recharge/tabs');
//     // const data: RechargeTabApiResponse = await response.json();

//     // 暂时使用模拟数据
//     const mockResponse: RechargeTabApiResponse = {
//       code: 200,
//       message: 'success',
//       data: mockRechargeTabData,
//     };

//     if (mockResponse.code === 200) {
//       return mockResponse.data.map(item => ({
//         id: item.id,
//         icon: item.icon,
//         title: item.title,
//         // 比例和文案
//         bonus: item.bonus || '',
//         bonusText: item.bonusText || '',
//         backgroundIndex: item.backgroundIndex,
//         isActive: item.isActive || false,
//         rules: item.rules || [],
//         minAmount: item.minAmount,
//         maxAmount: item.maxAmount,
//       }));
//     }

//     throw new Error(mockResponse.message);
//   } catch (error) {
//     console.error('获取充值tab数据失败:', error);
//     throw error;
//   }
// };

// 更新tab选中状态
export const updateTabActiveStatus = async (
  tabId: number,
  isActive: boolean,
): Promise<boolean> => {
  try {
    console.log('updateTabActiveStatus', tabId, isActive);
    // 这里应该是真实的API调用
    // const response = await fetch('/api/recharge/tabs/status', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({ tabId, isActive }),
    // });
    // const data = await response.json();

    // 暂时返回成功
    return true;
  } catch (error) {
    console.error('更新tab状态失败:', error);
    throw error;
  }
};

// mock getMultiple
export const mockGetMultiple = () => {
  return Promise.resolve(5);
};

// mock getVipWeekCardConfigList
// 支付页面打水倍数展示
// 返回倍数
// /pay/wallet/multiple
export const getMultiple = () => {
  // mockGetMultiple
  return http.post<null, number>('/app/pay/wallet/multiple');
};

export interface VipWeekCardReward {
  bonusAmount: number;
  day: number;
  scratchCount: number;
  spinCount: number;
}

export interface VipWeekCardConfig {
  bonus: number;
  cardId: number;
  cardName: string;
  price: number;
  scratchName: string;
  vipWeekCardRewardList: VipWeekCardReward[];
}
// vip 充值 周卡列表详情每天
// vip周卡规则接口
// /vip/getVipWeekCardConfigList
export const getVipWeekCardConfigList = () => {
  // 模拟数据
  // const mockConfigs = [
  //   {
  //     id: 1,
  //     name: 'Week 1',
  //     minAmount: 100,
  //     maxAmount: 1000,
  //     valueType: 'PERCENT_VALUE',
  //     value: '50',
  //   },
  //   {
  //     id: 2,
  //     name: 'Week 2',
  //     minAmount: 200,
  //     maxAmount: 2000,
  //     valueType: 'PERCENT_VALUE',
  //     value: '100',
  //   },
  // ];
  // return Promise.resolve(mockConfigs);
  return http.post<null, VipWeekCardConfig[]>(
    '/app/vip/getVipWeekCardConfigByDayList',
  );
};

// 支付页面活动 type 活动支付列表
// /promotion/activity/pay/list
export const getActivityPayList = (useType?: number) => {
  return http.post<{useType?: number}, Array<ActivityPay>>(
    '/app/promotion/activity/pay/list',
    {
      useType,
    },
  );
};

export const getBalanceConfig = (useType?: number) => {
  return http.post<null, Array<BalanceConfig>>(
    '/app/pay/wallet/balanceConfig',
    {
      useType,
    },
  );
};
